export default () => ({
  channelData: {},
  channelsList: [],
  followingList: [],
  followingCount: 0,
});

export function clearFollowingList(state) {
  state.followingList = [];
  state.followingCount = 0;
}
